document.addEventListener("DOMContentLoaded", () => {
    const form = document.getElementById("ContactLeaderboard");
    const nameInput = document.getElementById("ContactLeaderboard-name");
    const emailInput = document.getElementById("ContactLeaderboard-email");
    const phoneInput = document.getElementById("ContactLeaderboard-phone");
    const languageSelect = document.getElementById("ContactLeaderboard-language");
    const customVoteInput = document.getElementById("ContactLeaderboard-custom-vote-wrapper");
    const customVoteInputField = document.getElementById("ContactLeaderboard-custom-vote");
    const tagsInput = document.getElementById("ContactLeaderboard-tags");
    const errorElement = document.getElementById("ContactLeaderboard-error");
    
    const AWS_VOTE_ENDPOINT = "https://5a242lz7s1.execute-api.us-east-2.amazonaws.com/dev/vote";

    const currentUrl = window.location.href;
    if (currentUrl.includes("customer_posted=true")) {
        if (currentUrl.includes("language-leaderboard")) {
            return;
        } else {
            // Redirect to the leaderboard page if customer_posted=true is present
            window.location.href = "/pages/language-leaderboard?customer_posted=true";
            return;
        }
    }

    if (!form || !nameInput || !emailInput || !phoneInput || !languageSelect || !customVoteInput || !customVoteInputField || !tagsInput) {
        console.error("Required form elements are missing.");
        if (!form) {
            console.error("Form element not found");
        }
        if (!nameInput) {
            console.error("Name input not found");
        }
        if (!emailInput) {
            console.error("Email input not found");
        }
        if (!phoneInput) {
            console.error("Phone input not found");
        }
        if (!languageSelect) {
            console.error("Language select input not found");
        }
        if (!customVoteInput) {
            console.error("Custom vote input wrapper not found");
        }
        if (!customVoteInputField) {
            console.error("Custom vote input field not found");
        }
        if (!tagsInput) {
            console.error("Tags input not found");
        }
        return;
    }

    // Helper function to show error message
    function showError(message) {
        if (errorElement) {
            // Preserve the SVG wrapper, update the text content
            const svgWrapper = errorElement.querySelector('.svg-wrapper');
            const errorText = errorElement.querySelector('.error-text') || document.createElement('span');
            
            // Remove existing text nodes and non-SVG elements
            Array.from(errorElement.childNodes).forEach(node => {
                if (node !== svgWrapper && node !== errorText) {
                    errorElement.removeChild(node);
                }
            });
            
            // Set error message text
            if (!errorText.classList.contains('error-text')) {
                errorText.classList.add('error-text');
                errorElement.appendChild(errorText);
            }
            errorText.textContent = message;
            
            errorElement.style.display = "block";
            errorElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } else {
            console.error("AWS Error:", message);
            alert(message); // Fallback if error element doesn't exist
        }
    }

    // Helper function to hide error message
    function hideError() {
        if (errorElement) {
            errorElement.style.display = "none";
        }
    }

    // Hide custom vote field by default
    customVoteInput.style.display = "none";

    // Toggle custom vote input
    languageSelect.addEventListener("change", () => {
        console.log('changed languageSelect:', languageSelect.value);
        const isCustom = languageSelect.value === "new-vote";
        customVoteInput.style.display = isCustom ? "block" : "none";
    });

    form.addEventListener("submit", async (event) => {
        event.preventDefault(); // Prevent default submission until AWS vote succeeds
        
        // Get values
        const email = emailInput.value.trim();
        const isCustom = languageSelect.value === "new-vote";
        const languageName = isCustom ? customVoteInputField.value.trim() : languageSelect.value;

        // Validate
        if (!languageName) {
            showError("Please select a language or enter a custom vote.");
            return;
        }
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            showError("Please enter a valid email.");
            return;
        }

        // Hide any previous errors
        hideError();

        // Set tags
        const languageTag = languageName.toLowerCase().replace(/\s+/g, "_");
        const tags = ["leaderboard"];
        if (isCustom) {
            tags.push("new-vote", languageTag);
        } else {
            tags.push(languageTag);
        }
        tagsInput.value = tags.join(",");

        // Normalize language name to lowercase for AWS
        const normalizedLanguage = languageName.toLowerCase();

        try {
            // Send vote to AWS (for both existing and custom votes)
            const votePayload = {
                language: normalizedLanguage,
                email: email
            };

            const response = await fetch(AWS_VOTE_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(votePayload)
            });

            const result = await response.json();

            // Check for error response
            if (result.error) {
                showError(result.error);
                return; // Prevent form submission
            }

            // Success - check for message field
            if (result.message) {
                console.log("AWS vote recorded successfully:", result);
                // Now submit to Shopify contact form
                form.submit();
            } else {
                // Unexpected response format
                console.warn("Unexpected AWS response format:", result);
                // Still allow submission to Shopify
                form.submit();
            }
        } catch (error) {
            console.error("Failed to send vote to AWS:", error);
            showError("Network error: Unable to submit vote. Please try again.");
            return; // Prevent form submission on network error
        }
    });
});